import { Helmet } from "react-helmet-async";
import { BodyText, Button, Flex, Heading, Stack } from "@knowtex-ai/components";
import KnowtexLogo from "../KnowtexLogo";
import { isStandaloneUser } from "../../utils/standaloneUser";

export default function SessionExpired() {
  const standalone = isStandaloneUser();

  return (
    <main
      id="main-content"
      tabIndex={-1}
      className="flex min-h-screen w-[100dvw] items-center justify-center bg-white px-6 focus:outline-none"
    >
      <Helmet>
        <title>Session Expired – Knowtex</title>
      </Helmet>
      <div className="max-w-md text-center">
        <Stack gap={40}>
          <div role="img" aria-label="Knowtex" className="flex justify-center text-accent2">
            <KnowtexLogo />
          </div>
          <Stack gap={12}>
            <Heading as="h1">Your session has expired</Heading>
            <BodyText>
              {standalone
                ? "For your security, Knowtex signed you out. Sign in again to continue."
                : "For your security, Knowtex signed you out. Close this window and relaunch Knowtex from CPRS to continue."}
            </BodyText>
          </Stack>
          {standalone && (
            <Flex justifyContent="center">
              <Button to="/standalone">Sign in again</Button>
            </Flex>
          )}
        </Stack>
      </div>
    </main>
  );
}
